export default {
  pink: "#e5a9ab",
  golden: "#baa757",
  green: "#56b383",
  gray: "#717473",
  blue: "#006c8a",
  darkBlue: "rgb(19, 88, 131)",
  lightBlue: "#33c5f4"
};
